import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'

export enum TimeIntervals {
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY'
}

export interface TimeIntervalProxyType {
  timeInterval: TimeIntervals
}

export const timeIntervalProxy: TimeIntervalProxyType = proxy({
  timeInterval: TimeIntervals.Weekly
})

devtools(timeIntervalProxy, { name: 'timeIntervalProxy' })
